<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

 jQuery( document ).ready(function($) {

   $('.two-col-image-slider__slider').slick({
     dots: true,
     arrows: false,
     infinite: false
   });

   var collectionToggle = $('.toolbar-icon.icon-mode.icon-mode-list.grid-1');

   if(collectionToggle && $( window ).width() < 720){
    collectionToggle.trigger('click');
   }

   var ContactFlyout = (function () {
    var $footer_links = $("a");
    var contactFlyout = $("#contact-flyout");
    var closeFlyout = $(".contact-flyout__close");
    var $body = $("body");
    var openContact = $(".open-contact");
    var href = "";

    

    $("main").click(function () {
      if (contactFlyout.hasClass("active")) {
        contactFlyout.removeClass("active");
        $body.removeClass("body--overlay");
        contactFlyout.attr("aria-modal","false"); 
        contactFlyout.attr("aria-role",""); 
      }
    });  

    $(document).keydown(function(event) { 
      if (event.keyCode == 27) {
        contactFlyout.removeClass("active");
        $body.removeClass("body--overlay");
        contactFlyout.attr("aria-modal","false"); 
        contactFlyout.attr("aria-role",""); 
      }
    });

    $footer_links.click(function (e) {
      href = $(this).attr("href");
      
      if (href.indexOf("/contact") > -1) {
        console.log('contact button click');
        e.preventDefault();
        setTimeout(() => {
          contactFlyout.addClass("active");
          $body.addClass("body--overlay");
          contactFlyout.attr("aria-modal","true"); 
          contactFlyout.attr("aria-role","dialog"); 
          console.log("this should open modal " + href);
        }, 50); 
      }
    });

    openContact.click(function (e) {
      e.preventDefault();

      contactFlyout.addClass("active");
      $body.addClass("body--overlay");
      contactFlyout.attr("aria-modal","true"); 
      contactFlyout.attr("aria-role","dialog"); 

    });

    closeFlyout.click(function () {
      contactFlyout.removeClass("active");
      $body.removeClass("body--overlay");
      contactFlyout.attr("aria-modal","false"); 
      contactFlyout.attr("aria-role",""); 
    });

  })();

  $('.mobileMenu-toggle, .background-overlay').click(function(){
    let headerHeight = $("sticky-header.header-wrapper").height();
    let toolbar = $('.announcement-bar__message').height() || 0;
    let mobileHeaderHeight = toolbar + headerHeight;
    mobileHeaderHeight = mobileHeaderHeight + "px"
    setTimeout(function(){
      console.log( `${$('body').hasClass('menu_open')} mobile header is ${mobileHeaderHeight}`);

      if($(window).width() < 960 && $('body').hasClass('menu_open')  ) {
        $('.menu_open .halo-sidebar.halo-sidebar_menu').css("transform", `translateY(${ mobileHeaderHeight })`);
        //$(".background-overlay").css("transform", `translateY(${ mobileHeaderHeight })`);
      } else {
        console.log("remove transform");
        $('.halo-sidebar.halo-sidebar_menu').css("transform", ``);
      }

    },200);
       
    
  });
});